import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from '../components/dashboard/AdminDashboard';
import StaffDashboard from '../components/dashboard/StaffDashboard';
import CommunityHub from '../components/dashboard/CommunityHub';
import ProponentDashboard from '../components/dashboard/ProponentDashboard';
import '../components/dashboard/AdminDashboard.css';

export default function DashboardPage() {
  const { user, panel } = useAuth();
  if (panel === 'admin') return <AdminDashboard />;
  if (panel === 'staff') return <StaffDashboard />;
  if (panel === 'proponent') return <ProponentDashboard />;
  if (panel === 'genpop') return <div className="page dashboard-page dashboard-page--genpop">
    <h1>Welcome, {user?.firstName || user?.email}</h1>
    <p>Join your community to access its consultations, news and tools.</p>
    <Link to="/membership">Find or claim community membership</Link>
    <p>Already submitted a claim? Check the membership page for its review status.</p>
  </div>;
  return <CommunityHub />;
}
